import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedLanguage: "english",

};

const authSlice = createSlice({
  name: "loginPage",
  initialState,
  reducers: {
    setSelectedLanguage(state, action) {
      state.selectedLanguage = action.payload;
    },
  },
});

export const {
  setSelectedLanguage
} =
  authSlice.actions;
export default authSlice.reducer;
